module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold.a8023476.woff";